exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._26H9I{font-size:1.5em;margin-bottom:8px;margin-bottom:.5rem;display:block;font-weight:500;line-height:1.333333;text-transform:uppercase}._3l7ap p:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"title": "_26H9I",
	"content": "_3l7ap"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Teaser/Teaser.css
// module id = 688
// module chunks = 2